import { LoginBySessionInterface } from "../general/auth";

export type ApiCallState = {
  loading: boolean;
  errorMessage?: string;
  error: boolean;
};

export interface Page<T> {
  content: T[];
  empty?: boolean;
  first?: boolean;
  last?: boolean;
  number: number;
  numberOfElements: number;
  pageable?: Pageable;
  page: number;
  size: number;
  totalPages: number;
  totalElements: number;
  sort: Sort;

  grossBusinessTotal?: number;
}

export interface Pageable {
  sort: Sort;
  pageNumber: number;
  pageSize: number;
  offset: boolean;
  paged: boolean;
  unpaged: boolean;
}

export interface Sort {
  unsorted: boolean;
  sorted: boolean;
  empty: boolean;
}

export interface GetCall<T> extends ApiCallState {
  page: Page<T>;
}

export interface DeleteResponse<R, B> {
  deleted: boolean;
  blockingResources: B[];
  deletedResource: R;
}

export const ApiCallStateInitial = {
  data: {},
  loading: false,
  error: false,
};

export const LoginBySessionInitial: LoginBySessionInterface = {
  data: {},
  loading: false,
  error: false,
  fulfilled: false,
};

export const initialPage = {
  content: [],
  empty: false,
  first: false,
  last: false,
  number: 0,
  numberOfElements: 0,
  pageable: {
    sort: { unsorted: true, sorted: false, empty: false },
    pageNumber: 0,
    pageSize: 25,
    offset: false,
    paged: false,
    unpaged: false,
  },
  page: 0,
  size: 25,
  totalPages: 1,
  totalElements: 0,
  sort: {
    unsorted: false,
    sorted: false,
    empty: false,
  },
};

export interface PaginationRequestParam {
  page: number;
  pageSize: number;
  sort: string;
}

export type GenericError = {
  error: string;
  message: string;
  path: string;
  status: number;
  timestamp: string;
};
